import PropTypes from 'prop-types';
import React from 'react';
import { noop } from 'lodash';

const ImageWithFallback = ({ alt, className, fallbackImageUrl, imageUrl, onError }) => {
    return (
        <img
            alt={alt}
            className={className}
            src={imageUrl || fallbackImageUrl}
            onError={(e) => {
                e.target.src = fallbackImageUrl;
                onError();
            }}
        />
    );
};

ImageWithFallback.defaultProps = {
    className: '',
    onError: noop,
};

ImageWithFallback.propTypes = {
    alt: PropTypes.string.isRequired,
    className: PropTypes.string,
    fallbackImageUrl: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    onError: PropTypes.func,
};

ImageWithFallback.displayName = 'ImageWithFallback';

export default ImageWithFallback;
